<template>
  <base-section
    id="services"
  >
    <template />
    <base-section-heading
      v-intersect.quiet="{
        handler: onIntersect,
        options: {
          threshold: [0.5]
        }
      }"
      title="WHAT WE DO"
    >
      These are some of the services we can offer you.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="(service, i) in services"
          :key="i"
          cols="12"
          md="4"
          sm="6"
        >
          <base-avatar-card
            v-bind="service"
            align="left"
            horizontal
          >
            {{ service.description }}
          </base-avatar-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import { eventBus } from '../../main'

  export default {
    name: 'SectionServices',

    data: () => ({
      services: [
        {
          color: 'primary',
          dark: true,
          title: 'Software development',
          icon: 'mdi-code-braces',
          description: 'Full-stack and full-cycle development for multi-platform and multi-proposes solutions, involving analysis, design, programming, and deployment operations. In both back-end and front-end, we have strong experience creating and maintaining high quality applications, systems, and integrations for different business areas.',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Web systems',
          icon: 'mdi-responsive',
          description: 'We create and implement large solutions based on web environment. Flexible and scalable web systems, with functional and friendly experiences, thanks to the modern front-end technologies and services-oriented architectures. Our responsive web developments, from simple sites to complex applications, can run efficiently over all devices and screen sizes.',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Mobile applications',
          icon: 'mdi-cellphone',
          description: '100% native applications for both Android and iOS operative systems, using the most modern technologies for mobile development. Focused on end-user experiences, we build beautiful and performant mobile apps taking advantage of the native approach and its benefits, including push notifications, reminders, access to camera, files, calendar, GPS, and more features.',
        },
        {
          title: 'Data modeling & analysis',
          icon: 'mdi-database',
          description: 'From transaction processing solutions with relational structures, to dimensional models for decision support systems, we apply effective strategies designing and building databases for every business objective. By implementing Business Intelligence processes, we provide data warehousing and many ways and tools to data processing, analysis, and reporting.',
        },
        {
          title: 'Cloud solutions',
          icon: 'mdi-cloud-tags',
          description: 'Cloud based services for building, managing, and deploying applications and services supporting every development operation. We provide solutions with scalable and secure infrastructure, using most of the possible benefits of cloud computing and its features. High availability and performance reducing risks and costs.',
        },
        {
          title: 'Software consulting',
          icon: 'mdi-account-group',
          description: 'We can help your organization in its digital transformation, fully develop your project, or improve your processes, providing any of the mentioned services. Through outsourcing, as partners, or guiding you to do it yourself, we are prepared to support your IT needs. Whether you are a software company or not, you can count on us.',
        },
      ],
    }),
    methods: {
      onIntersect (entries, observer) {
        if (entries[0].intersectionRatio >= 0.5) {
          eventBus.$emit('selectTab', 'services')
        }
      },
    },
  }
</script>
